// src/pages/RepayLoan.js
import React, { useState, useEffect, memo } from 'react';
import './repay-loan.css';
import { FaDownload } from 'react-icons/fa'; 

// Bank Assets Imports
import sbiLogo from '../assets/images/SBI-Logo.png';
// import idfcQr from '../assets/images/idfcqrcode.png';

// Bank Data Array
const banks = [
  {
    name: 'STATE BANK OF INDIA',
    logo: sbiLogo,
    // qr: idfcQr,
    // upi: 'marathonpvtltd@idfcbank',
    accountName: 'SINGH FINLEASE PRIVATE LIMITED',
    accountNumber: '45170543367',
    ifsc: 'SBIN0001181',
    branch: 'SME NAJAFGARH ROAD NEW DELHI',
    accountType: 'Current Account',
  },
];

// Memoized Bank Card
const BankCard = memo(({ bank }) => (
  <div className="row align-items-center repay-card mb-5 p-4 shadow rounded-4 bg-white">
    <div className="col-md-7 mb-4 mb-md-0">
      <div className="text-center mb-3">
        <img src={bank.logo} alt={`${bank.name} logo`} className="bank-logo mb-2" style={{ height: '60px' }} />
      </div>
      <h4 className="fw-bold text-primary">Bank Details</h4>
      <div className="bank-details ps-md-3">
        <p><strong>Bank Name:</strong> {bank.name}</p>
        <p><strong>Company Name:</strong> {bank.accountName}</p>
        <p><strong>Account No.:</strong> {bank.accountNumber}</p>
        <p><strong>IFSC Code:</strong> {bank.ifsc}</p>
        <p><strong>Branch Name:</strong> {bank.branch}</p>
        <p><strong>Account Type:</strong> {bank.accountType}</p>
      </div>
    </div>

    <div className="col-md-5 text-center">
      <h4 className="fw-bold text-primary">QR Code / UPI</h4>
      <p className="fw-semibold">SCAN & PAY</p>

      {bank.qr && (
        <img
          src={bank.qr}
          alt={`${bank.name} QR Code`}
          className="qr-image mb-3"
          style={{ width: '260px', borderRadius: '10px' }}
        />
      )}

      {bank.upi && (
        <p className="mb-0"><strong>UPI ID:</strong> {bank.upi}</p>
      )}
    </div>
  </div>
));


const RepayLoan = () => {
  const [mobile, setMobile] = useState('');
  const [customer, setCustomer] = useState(null);
  const [error, setError] = useState('');
  const [paying, setPaying] = useState(false);
  const [payUing, setPayUing] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const [inputError, setInputError] = useState('');

  /* ===== Load Paytm SDK (STAGING) ===== */
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://secure.paytmpayments.com/merchantpgpui/checkoutjs/merchants/Vanshi31581444435768.js";
    script.async = true;

    script.onload = () => console.log("✅ Paytm SDK Loaded");
    script.onerror = () => console.error("❌ Paytm SDK Failed");

    document.body.appendChild(script);

    return () => {
      if (window.Paytm?.CheckoutJS) {
        window.Paytm.CheckoutJS.close();
      }
      document.body.removeChild(script);
    };
  }, []);

  // Search customer by mobile or PAN
  const handleSearch = async (e) => {
    e.preventDefault();
    setError('');
    setCustomer(null);
    setIsOTPVerified(false);
    setShowOTP(false);
    setOtp('');

    // Validation
    if (!mobile.trim()) {
      setError('Please enter Mobile Number or PAN Number');
      return;
    }

    if (!validateInput(mobile.trim())) {
      if (/^\d{10}$/.test(mobile.trim())) {
        setError('Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9');
      } else if (/^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/.test(mobile.trim())) {
        setError('Please enter a valid PAN number (e.g., ABCDE1234F)');
      } else {
        setError('Please enter a valid 10-digit mobile number or PAN number');
      }
      return;
    }

    // Send OTP for both mobile and PAN
    setIsSearched(true); // Disable submit button

    try {
      let requestBody = `mobile=${encodeURIComponent(mobile.trim())}`;
      
      if (/^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/.test(mobile.trim())) {
        requestBody += `&pan=${encodeURIComponent(mobile.trim().toUpperCase())}`;
      }

      console.log('Send OTP Request Body:', requestBody);

      const response = await fetch('https://loansalary.in/Api/TaskApi/sendOtp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: requestBody
      });

      const result = await response.json();
      console.log('Send OTP Response:', result);

      if (result.status) {
        setShowOTP(true);
        setError('');
      } else {
        setError(result.message || 'Failed to send OTP');
        setIsSearched(false); 
      }
      
    } catch (err) {
      setError('Something went wrong. Please try again.');
      console.error(err);
      setIsSearched(false); 
    }
  };

  const handleOTPSubmit = async (e) => {
    e.preventDefault();
    setIsVerifying(true);
    setError('');

    try {
      let requestBody = `mobile=${encodeURIComponent(mobile.trim())}&otp=${encodeURIComponent(otp.trim())}`;
      
      if (/^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/.test(mobile.trim())) {
        requestBody += `&pan=${encodeURIComponent(mobile.trim().toUpperCase())}`;
      }

      console.log('Verify OTP Request Body:', requestBody);

      const response = await fetch('https://loansalary.in/Api/TaskApi/verifyOtp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: requestBody
      });

      const result = await response.json();
      console.log('Verify OTP Response:', result);

      if (result.status) {
        setIsOTPVerified(true);
        setShowOTP(false);
        await fetchCustomerData();
      } else {
        setError(result.message || 'Invalid OTP. Please try again.');
      }
      
    } catch (err) {
      setError('OTP verification failed. Please try again.');
      console.error(err);
    } finally {
      setIsVerifying(false);
    }
  };

  // Fetch customer data after OTP verification
  const fetchCustomerData = async () => {
    try {
      let apiUrl;
      if (/^\d{10}$/.test(mobile.trim())) {
        apiUrl = `https://loansalary.in/Api/TaskApi/oldUserHistory?mobile=${mobile.trim()}`;
      } else {
        apiUrl = `https://loansalary.in/Api/TaskApi/oldUserHistory?pancard=${mobile.trim().toUpperCase()}`;
      }

      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data?.listTask?.length > 0) {
        const user = data.listTask[0];

        setCustomer({
          name: user.first_name,
          mobile: user.mobile,
          lead_id: user.lead_id,
          loan_no: user.loan_no,
          pan: user.pancard,
          repayAmount: user.total_repayable,
          tillDateRepayAmount: user.repayment_amount,
          repayDate: user.repayment_date,
          status: user.status,
          email: user.email || 'user@example.com',
          id: user.id || 'CUS',
        });

        setError('');
      } else {
        setCustomer(null);
        setError('Customer not found');
        setIsOTPVerified(false);
        setIsSearched(false);
      }
    } catch (err) {
      console.error(err);
      setCustomer(null);
      setError('Failed to fetch customer data. Please try again.');
      setIsOTPVerified(false);
      setIsSearched(false);
    }
  };

  const handleReset = () => {
    setMobile('');
    setCustomer(null);
    setError('');
    setShowOTP(false);
    setOtp('');
    setIsVerifying(false);
    setIsOTPVerified(false);
    setIsSearched(false);
    setInputError('');
  };

  const handleDownload = () => {
    const receiptData = {
      customerName: customer.name,
      mobileNumber: customer.mobile,
      panNumber: customer.pan,
      repayAmount: customer.repayAmount,
      tillDateRepayAmount: customer.tillDateRepayAmount,
      status: customer.status,
      repayDate: customer.repayDate,
      leadId: customer.lead_id,
      loanNo: customer.loan_no,
      downloadDate: new Date().toLocaleString()
    };

    const dataStr = JSON.stringify(receiptData, null, 2);
    const blob = new Blob([dataStr], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `receipt_${customer.mobile}_${Date.now()}.json`;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const forceDownload = () => {
    const fileUrl = 'https://loansalary.in/upload/ESIGN_sanction_letter_43719_8358.pdf';

    const fileName = customer
      ? `Sanction_Letter_${customer.name}.pdf`
      : 'Sanction_Letter.pdf';

    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', fileName);
    link.setAttribute('target', '_self'); 

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setMobile(value);
    
    if (value.trim()) {
      setError('');
      setInputError('');
    }
    
    if (value.trim() && !validateInput(value.trim())) {
      if (value.length === 10 && /^\d+$/.test(value)) {
        setInputError('Mobile number must start with 6, 7, 8, or 9');
      } else if (value.length === 10 && /^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/.test(value)) {
        setInputError('Invalid PAN format');
      } else if (value.length > 0) {
        setInputError('Enter 10-digit mobile or PAN number');
      }
    } else {
      setInputError('');
    }
  };

  const validateMobile = (mobile) => {
    const mobileRegex = /^[6-9]\d{9}$/;
    return mobileRegex.test(mobile);
  };

  const validatePAN = (pan) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panRegex.test(pan.toUpperCase());
  };

  const validateInput = (input) => {
    if (/^\d{10}$/.test(input)) {
      return validateMobile(input);
    }
    else if (/^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/.test(input)) {
      return validatePAN(input);
    }
    return false;
  };

  /* ===== PAY NOW ===== */
  const payNow = async () => {
    if (paying) return;

    if (!window.Paytm || !window.Paytm.CheckoutJS) {
      alert("Paytm SDK not loaded");
      return;
    }

    setPaying(true);

    try {
      const res = await fetch("https://loansalary.in/paytm/initiate", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `amount=${encodeURIComponent(customer.repayAmount)}&lead_id=${encodeURIComponent(customer.lead_id)}&loan_no=${encodeURIComponent(customer.loan_no)}`,
      });

      if (!res.ok) {
        throw new Error("Server error: " + res.status);
      }

      const resp = await res.json();
      console.log("PAYTM INIT RESP:", resp);

      if (!resp.status) {
        alert(resp.message || "Transaction init failed");
        setPaying(false);
        return;
      }

      await window.Paytm.CheckoutJS.init({
        flow: "DEFAULT",
        data: {
          orderId: resp.orderId,
          token: resp.txnToken,
          tokenType: "TXN_TOKEN",
          amount: resp.amount,
        },
        handler: {
          notifyMerchant: function (eventName, data) {
            console.log("PAYTM EVENT:", eventName, data);
          },
        },
      });

      window.Paytm.CheckoutJS.invoke();

    } catch (err) {
      console.error("PAY ERROR:", err);
      alert("Payment failed");
    } finally {
      setPaying(false);
    }
  };

  const payUNow = async () => {
    if (payUing || !customer) return;

    setPayUing(true);

    try {
      const params = new URLSearchParams();
      params.append("amount", customer.repayAmount);
      params.append("lead_id", customer.lead_id);
      params.append("name", customer.name);
      params.append("email", customer.email);
      params.append("mobile", customer.mobile);
      params.append("loan_no", customer.loan_no);

      const res = await fetch("https://loansalary.in/payu/generatePayUHash ", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params.toString(),
      });

      if (!res.ok) {
        throw new Error("Server error");
      }

      const resp = await res.json();
      console.log("PAYU RESP:", resp);

      if (!resp.status) {
        alert(resp.message || "PayU init failed");
        return;
      }

      const form = document.createElement("form");
      form.method = "POST";
      form.action = resp.payu_url;

      for (const key in resp.params) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = resp.params[key];
        form.appendChild(input);
      }

      document.body.appendChild(form);
      form.submit();

    } catch (error) {
      console.error("PAYU ERROR:", error);
      alert("Payment failed. Please try again.");
    } finally {
      setPayUing(false);
    }
  };

  return (
    <div className="repay-loan-page">

      {/* Hero Section */}
      <section className="hero-section text-white text-center py-3">
        <div className="container">
          <h1 className="fw-bold">Repay Your Loan</h1>
          <p className="lead mt-3 repay-subtitle">
            Choose your preferred bank and make hassle-free repayments.
          </p>
        </div>
      </section>

      {/* Search Form */}
      <section className="container mt-5">
        <div className="search-container">
          <form onSubmit={handleSearch} className="d-flex flex-column flex-md-row align-items-md-center gap-3 mb-4">
            <div className="input-group-custom">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Mobile Number / PAN Number"
                value={mobile}
                onChange={handleInputChange}
                required
                disabled={isSearched}
              />
              {inputError && <div className="validation-error">{inputError}</div>}
            </div>
            <button 
              type="submit" 
              className="btn custom-submit-btn"
              disabled={isSearched || !mobile.trim()}
            >
              {isSearched ? 'OTP Sent' : 'Submit'}
            </button>
          </form>

          {/* OTP Verification Field */}
          {showOTP && (
            <form onSubmit={handleOTPSubmit} className="d-flex flex-column flex-md-row align-items-md-center gap-3 mb-4">
              <div className="input-group-custom">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  maxLength={6}
                  required
                />
              </div>
              <button type="submit" className="btn custom-submit-btn" disabled={isVerifying}>
                {isVerifying ? 'Verifying...' : 'Verify OTP'}
              </button>
            </form>
          )}
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        {/* Reset Button */}
        {isSearched && (
          <div className="text-center mb-4">
            <button 
              type="button" 
              className="btn btn-outline-secondary btn-sm"
              onClick={handleReset}
            >
              Start New Search
            </button>
          </div>
        )}

        {/* Customer Details Table */}
        {isOTPVerified && customer && (
          <div className="table-responsive mb-5">
            <table className="table table-bordered text-center align-middle">
              <thead className="table-light">
                <tr>
                  <th>Customer Name</th>
                  <th>Mobile Number</th>
                  <th>PAN No</th>
                  <th>Repay Amount</th>
                  <th>Till Date Repay Amount</th>
                  <th>Status</th>
                  <th>Repay Date</th>
                  <th>Paytm</th>
                  <th>PayU</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{customer.name}</td>
                  <td>{customer.mobile}</td>
                  <td>{customer.pan}</td>
                  <td>₹{customer.tillDateRepayAmount}</td>
                  <td>₹{customer.repayAmount}</td>
                  <td>{customer.status}</td>
                  <td>{customer.repayDate}</td>
                  <td>
                    <form>
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={payNow}
                        disabled={paying}
                      >
                        {paying ? "Processing..." : "Pay Now"}
                      </button>
                    </form>
                  </td>

                  <td>
                    <form>
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={payUNow}
                        disabled={payUing}
                      >
                        {payUing ? "Processing..." : "PayU Now"}
                      </button>
                    </form>
                  </td>
                  <td className="text-center">
                    <button 
                      className="btn btn-success btn-sm"
                      onClick={() => forceDownload()} 
                      title="Download Sanction Letter"
                    >
                      <FaDownload />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </section>

      {/* Render Static Bank Details Section */}
      <section className="mt-5 bg-light py-4">
        <div className="container">
          {banks.map((bank, index) => (
            <BankCard key={index} bank={bank} />
          ))}
        </div>
      </section>

    </div>
  );
};

export default RepayLoan;